export default function ConsentBar({ visible, onAccept, onReject }) {
  if (!visible) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 p-4 bg-blue-50 border-t">
      <div className="max-w-3xl mx-auto flex items-center justify-between gap-3">
        <p className="text-sm">
          We use this chat to improve our service. Do you consent to processing your messages per our privacy policy?
        </p>
        <div className="flex gap-2">
          <button className="px-3 py-1 rounded bg-gray-200" onClick={onReject}>Decline</button>
          <button className="px-3 py-1 rounded bg-blue-600 text-white" onClick={onAccept}>Accept</button>
        </div>
      </div>
    </div>
  );
}
